import PaymentNameAPI from "../../../api/PaymentNameAPI";
import AssetAPI from "../../../api/AssetAPI";

export default {
  async loadAllPaymentName({commit}) {
    let response = await new PaymentNameAPI().getAllPaymentName();
    commit('SET_ALL_PAYMENT_NAME', response);
    return response;
  },

  async loadAllPaymentKindsAndTypes({commit}) {
    let response = await new PaymentNameAPI().getPaymentKindsAndTypes();
    commit('SET_ALL_PAYMENT_KINDS_AND_TYPES', response);
    return response;
  },

  async createPayment({commit}, payment) {
    let response = await new PaymentNameAPI().createPayment(payment);
    commit('ADD_NEW_CREATED_PAYMENT', response);
    return response;
  },

  async updatePayment({ commit }, data) {
    const response = await new PaymentNameAPI().updatePayment(data);
    commit("UPDATE_PAYMENT_NAME", response);
  },


};
